import * as React from "react";
import { useQuery } from "@apollo/client";
import { getAuth, signOut } from "firebase/auth";
import { Routes, Route } from "react-router-dom";

import { ME } from "../graphql/me";
import Login from "../auth/Login";
import HomePage from "../home-page/HomePage";
import PumpsPage from "../pumps-page/PumpsPage";
import AccountPage from "../account-page/AccountPage";
import InvetAppBar from "../invet-app-bar/InvetAppBar";
import FalseBreakouts from "../breakouts-page/BreakoutsPage";

export default function MainPage({ isAuth }) {
	const auth = getAuth();
	const { loading, error, data } = useQuery(ME);
	if (loading) {
		return <div>Loading me...</div>;
	}
	if (!isAuth) {
		return (
			<>
				<Login />
			</>
		);
	}
	if (error) {
		return <div>Error communicating with server.</div>;
	}
	// if (data.me.role !== UserRoles.ADMIN && data.me.role !== UserRoles.MANAGER) {
	// 	return (
	// 		<>
	// 			<div>You're not admin or manager.</div>
	// 			<Button variant="outlined" onClick={() => signOut(auth)}>
	// 				Sign out
	// 			</Button>
	// 		</>
	// 	);
	// }
	return (
		<div>
			<InvetAppBar authScope={data.me.role} />
			<>
				<Routes>
					<Route path="/" element={<HomePage />}>
						<Route
							path="pumps"
							element={<PumpsPage authScope={data.me.role} />}
						/>
						<Route
							path="false-breakouts"
							element={<FalseBreakouts authScope={data.me.role} />}
						/>
						<Route
							path="account"
							element={<AccountPage authScope={data.me.role} />}
						/>
						{/* {(data.me.role === UserRoles.ADMIN ||
							data.me.role === UserRoles.MANAGER) && (
							<>
								<Route
									path="orders"
									element={<OrderPage authScope={data.me.role} />}
								/>
							</>
						)}
						{data.me.role === UserRoles.ADMIN && (
							<>
								<Route path="employee" element={<EmployeePage />} />
								<Route path="warehouses" element={<WarehousesPage />} />
								<Route path="vans" element={<VansPage />} />
							</>
						)} */}
					</Route>
				</Routes>
			</>
		</div>
	);
}
